export interface IBlogTemplate {
    id: number;
    title: string;
    img: string;
    html: string;
}
